import { render, staticRenderFns } from "./left_menu.vue?vue&type=template&id=172b6ed5"
import script from "./left_menu.vue?vue&type=script&lang=js"
export * from "./left_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports